/**
 * **BookOnlineNow**
 *
 * @exports partnership_52
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
       * @memberOf module:partnership_52
       */
    partnership.getId = function getId() {
        return '52';
    };
    /**
       * @memberOf module:partnership_52
       */
    partnership.check = function check() {
        // Checks if the meta tag named 'hotelid' exists
        return !!document.querySelector("meta[name='hotelid']");
    };
    /**
       * @memberOf module:partnership_52
       */
    partnership.getSiteId = function getSiteId() {
        // get hotel id from meta tag 'hotelid'
        const externalId = document.querySelector("meta[name='hotelid']").getAttribute('content');
        return externalId;
    };
    return partnership;
}

export { factory };
